<template>
    <div class="smsCode">
        <div class="box">
            <div class="left">
                <el-input v-model="imgCode" placeholder="请输入图形验证码"></el-input>
            </div>
            <div class="right">
                <rand-img :baseURL="randImgbaseURL" class="rand-img"></rand-img>
            </div>
        </div>
        <div class="box mt20">
            <div class="left">
                <el-input v-model="smsCode" placeholder="请输入短信验证码" :disabled="!imgCode||!mobile"></el-input>
            </div>
            <div class="right">
                <el-button size="small" class="mt1" :disabled="true" v-if="smsButtonCountDown">
                    <count-down v-model="smsButtonCountDown"></count-down> 秒后重试
                </el-button>
                <el-button v-else size="small" class="mt1" :disabled="!imgCode||!mobile" @click="generatorSMSCode">
                    获取验证码
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
import randImg from './randImg'
import countDown from './countDown'
export default {
    components: {
        randImg,
        countDown
    },
    data() {
        return {
            randImgbaseURL: __consoleURL +'/api-portal/randImg/rand?serverName=security',
            smsButtonCountDown: 0,
            imgCode: ''
        }
    },
    methods: {
        generatorSMSCode() {
            let params = {
                memberMobilePhone: this.mobile,
                randCode: this.imgCode,
                serverName: 'security'
            }
            $.get(__consoleURL + '/api-portal/api/register/generatorSMSCode', params).then(response => {
                let msgType = ''
                if(response.status&&response.status == '101'){
                    msgType = 'success'
                    this.smsButtonCountDown = 60
                }else{
                    msgType = 'error'
                }
                if (response && response.msg) {
                    this.$message({
                        type: msgType,
                        message: response.msg
                    })
                }
            },err => {
                this.smsButtonCountDown = 0
                // this.$message({
                //     type: 'error',
                //     message: 
                // })
            })
        }
    },
    computed: {
        smsCode: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    props: {
        mobile: {
            required: true,
        },
        value: {
            required: true
        }
    }
}
</script>
<style scoped>
.box {
    width: 100%;
    overflow: hidden;
}

.left {
    width: calc(100% - 102px);
    float: left;
}

.right {
    width: 92px;
    float: right;
    margin-top: 4px;
}

.right .rand-img {
    margin-top: -3px;
}
</style>



// WEBPACK FOOTER //
// src/Payment/components/components/smsCode.vue